module.exports = __webpack_public_path__ + "static/media/instagram.365bc8a2.svg";